module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-9-d5db2a019a9314820592a50cdfd5d5af.png";